<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <div class='h100vh-100'>
        <IdelTimeIndicatorThresholdTableButton @notice='notice'></IdelTimeIndicatorThresholdTableButton>
        <IdelTimeIndicatorThresholdTable ref="indicatorThreshold"></IdelTimeIndicatorThresholdTable>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import IdelTimeIndicatorThresholdTableButton from '../../components/alarmconfig/indicatorThreshold/IdelTimeIndicatorThresholdTableButton';
import IdelTimeIndicatorThresholdTable from '../../components/alarmconfig/indicatorThreshold/IdelTimeIndicatorThresholdTable';

export default {
  name: "IdelTimeIndicatorThresholdPage",
  components:{
    BasicLayout,
    IdelTimeIndicatorThresholdTableButton,
    IdelTimeIndicatorThresholdTable
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Alarm.alarmManage')}/${this.$t('Alarm.indicatorThreshold')}`
      }
    };
  },
  methods: {
    notice(type) {
      switch (type) {
        case 'add':
          this.$refs.indicatorThreshold.addFunc();
          break;
        case 'remove':
          this.$refs.indicatorThreshold.removeFunc();
          break;
        case 'edit':
          this.$refs.indicatorThreshold.editFunc();
          break;
        case 'refresh':
          this.$refs.indicatorThreshold.getIndicatorAlarmThresholdListData();
          break;
        case 'able':
          this.$refs.indicatorThreshold.updateStatusFunc('1');
          break;
        case 'disable':
          this.$refs.indicatorThreshold.updateStatusFunc('0');
          break;
        default:
      }
    }
  }
}
</script>

<style scoped>

</style>
